import { TinyTheme } from "src/course/domain/CourseEditModel";
import classes from "../SideBar.module.scss";
import LnIcon from "src/components/LnIcon";
import { IdAndNameAndSelectDto } from 'src/types';
import { useI18n } from "src/utils/lni18n";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import courseService from "src/course/CourseService";
import { urlService } from "src/services/NavService";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useConfirm } from "src/components/Modalservice/UseConfirm";

export default function PartCard(props: { readOnly: boolean, dragged?: boolean, partId?: string, part: IdAndNameAndSelectDto, theme: TinyTheme, currentCourseId: string }) {

    const { part, theme, currentCourseId, partId, dragged, readOnly } = props;

    const { languageService: t } = useI18n();
    const navigate = useNavigate();
    const confirm = useConfirm();
    const [selected, setSelected] = useState(false);

    useEffect(() => {
        setSelected(part.Id === partId);
    }, [partId, part.Id])

    const { partId: urlPartId } = useParams();

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: part.Id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: dragged ? "75%" : ""
    };



    function removePart(e: React.MouseEvent, themeId: string, part: IdAndNameAndSelectDto): void {
        e.preventDefault();
        e.stopPropagation();

        confirm("md", t.getText("remove"),
            <div className="preserve-white" >{t.getText("remove.x.from.course", `${part.Name}`)}</div>)
        .then(async (res: boolean) => {
            if (res) {
                const nextId = await courseService.removePart(currentCourseId, theme.Id, part.Id);

                if (urlPartId === partId) { // we are removing a part in edit - must navigate to other view
                    if (nextId) {
                        navigate(urlService.urlToPartInCourse(currentCourseId, themeId, nextId!));
                    }
                    else {
                        navigate(urlService.urlToCourse(currentCourseId));
                    }
                }
            }
        }).catch((e: Error) => { });

    }


    // The card is also the sortable node, and holds the drag handle and the remove button,
    // which cannot sit inside an <a>. So the name is the link, and `stretched-link` spreads
    // its click area over the whole card (`.part` is position: relative); the handle and the
    // button are lifted above it with z-2 so they keep working.
    return <div style={style} ref={setNodeRef} id={part.Id} key={part.Id}
        className={`pointer ${dragged ? classes.dragged : ""} ${classes.part} ${selected ? "selected" : ""}`}  >

        <div className='d-flex align-content-center w-100'>
            {!readOnly &&
                <div className={`ns-drag-cursor pe-3 z-2 ${classes.dragh}`} {...attributes} {...listeners}>
                    <LnIcon name="draghandle" className='icon-small' />
                </div>
            }

            <Link to={urlService.urlToPartInCourse(currentCourseId, theme.Id, part.Id, "texts")} draggable={false}
                className="stretched-link link-plain">{part.Name}</Link>
            <div className="ms-auto d-flex">
                {part.Dirty && <LnIcon name="alert" className='icon-small mb-2 me-2' />}
                <button onClick={(e) => removePart(e, theme.Id, part)} className="btn btn-link position-relative z-2" type="button">
                    <LnIcon name="delete" className='icon-small' />
                </button>
            </div>
        </div>

    </div>


}